import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiUser, FiBell, FiLogOut } from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';
import { usePermissions } from '../context/PermissionContext';
import authService from '../services/authService';

// Small account dropdown used in both the Sidebar header and the MobileDrawer header:
// EN/ES language toggle, Notification Preferences link, Logout — the same three
// "utility" items that lived at the bottom of the old Navbar dropdown, now separated
// from the actual page-navigation items.
//
// `align` controls which side the dropdown expands from ('right' = anchor's right edge,
// menu grows left; 'left' = anchor's left edge, menu grows right). The trigger button sits
// near the left edge in MobileDrawer, so align="left" there keeps the menu on-screen.
export default function AccountMenu({ onNavigate, align = 'right' }) {
  const { lang, setLang } = useLanguage();
  const { user } = usePermissions();
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  const handleLogout = () => {
    authService.clearToken();
    window.location.href = '/';
  };

  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ');

  return (
    <div className="position-relative" ref={ref}>
      <button
        className="btn btn-outline-light d-flex align-items-center justify-content-center"
        style={{ width: 36, height: 36, borderRadius: '50%', padding: 0 }}
        onClick={() => setOpen(v => !v)}
        title="Account"
      >
        <FiUser size={16} />
      </button>
      {open && (
        <div
          className="dropdown-menu show"
          style={{
            position: 'absolute',
            top: '110%',
            right: align === 'right' ? 0 : 'auto',
            left: align === 'left' ? 0 : 'auto',
            minWidth: 200,
            zIndex: 1100,
          }}
        >
          {(fullName || user?.username) && (
            <>
              <div className="dropdown-item-text" style={{ lineHeight: 1.3 }}>
                {fullName && <div style={{ fontSize: 14, fontWeight: 600 }}>{fullName}</div>}
                {user?.username && <div className="text-muted" style={{ fontSize: 12 }}>@{user.username}</div>}
              </div>
              <div className="dropdown-divider" />
            </>
          )}
          <div className="dropdown-item-text d-flex align-items-center gap-2" style={{ fontSize: 13 }}>
            <span className="text-muted">Language:</span>
            <button className={`btn btn-sm py-0 px-2 ${lang === 'en' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setLang('en')}>EN</button>
            <button className={`btn btn-sm py-0 px-2 ${lang === 'es' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setLang('es')}>ES</button>
          </div>
          <div className="dropdown-divider" />
          <Link className="dropdown-item d-flex align-items-center gap-2" to="/notifications" onClick={() => { setOpen(false); onNavigate?.(); }}>
            <FiBell size={14} /> Notification Preferences
          </Link>
          <div className="dropdown-divider" />
          <button className="dropdown-item d-flex align-items-center gap-2 text-danger" onClick={handleLogout}>
            <FiLogOut size={14} /> Logout
          </button>
        </div>
      )}
    </div>
  );
}
